/**
 * defineEnum.js — Factory that generates everything from a single config.
 *
 * Usage:
 *   const result = defineEnum({
 *     PENDING:  { value: 1, label: "Pending",  class: "on-hold" },
 *     APPROVED: { value: 2, label: "Approved", class: "active" },
 *   });
 *
 * Returns:
 *   result.values        → { PENDING: 1, APPROVED: 2 }
 *   result.meta          → { 1: { label, class }, 2: { label, class } }
 *   result.getLabel(1)   → "Pending"
 *   result.getClass(1)   → "on-hold"
 *   result.options       → [{ value: 1, label: "Pending" }, ...]
 *   result.filterOptions → [{ value: "all", label: "All" }, ...options]
 *
 * To add a new item, you add ONE line to the config — that's it.
 */
export function defineEnum(config) {
  const values = {};
  const meta = {};

  for (const [key, entry] of Object.entries(config)) {
    values[key] = entry.value;
    meta[entry.value] = { label: entry.label, class: entry.class };
  }

  const getLabel = (v) => meta[v]?.label ?? v;
  const getClass = (v) => meta[v]?.class ?? "";

  const options = Object.entries(config).map(([, entry]) => ({
    value: entry.value,
    label: entry.label,
  }));

  const filterOptions = [{ value: "all", label: "All" }, ...options];

  return { values, meta, getLabel, getClass, options, filterOptions };
}
